import { useCallback } from 'react'
import ApiService from 'services/ApiService'
import { getMessage } from 'utility/MapperResponse'
import { getTranslate } from 'utility/MapperTranslate'
import { showAlert } from 'utility/SweetAlert'

const InteractorAccountingHeaderCreate = () => {
  const accountingHeaderCreate = useCallback((body, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/transaction/fund-accounting/header-create', payload, (response) => {
      loading(false)
      if (response.code === 7201) {
        showAlert({
          icon: 'success',
          message: getTranslate('message.successfully_created'),
          timer: 2000,
          redirect: '/finance/balance/manage',
        })
      } else {
        showAlert({
          icon: 'error',
          message: getMessage(response?.msg),
          timer: 2000,
        })
      }
    })
  }, [])

  return { accountingHeaderCreate }
}

export default InteractorAccountingHeaderCreate
